import { get, set } from "@ember/object"
import Route from "@ember/routing/route"
import { later, scheduleOnce } from "@ember/runloop"
import { inject as service } from "@ember/service"
import { Promise } from "rsvp"

export default class PrintRoute extends Route {
  @service
  finder

  @service
  session

  // queryParams: {token: null, userId: null},
  model(params) {
    if (params.printToken) {
      set(this, "session.isPrinting", true)
      set(this, "session.token", params.printToken)
      set(this, "session.userId", params.printUserId)
    }
    let promiseCheckCount = 0
    const renderPromise = new Promise((resolve, reject) => {
      let poll = () => {
        // Ember.run.sync()
        later(() => {
          // Increment everytime we make the loop and we hvae no inFlightRequests
          if (get(this, "finder.inFlightRequests.length") === 0) {
            promiseCheckCount++
          }
          // Reset if we get new requests
          if (get(this, "finder.inFlightRequests.length") > 0) {
            promiseCheckCount = 0
          }
          if (get(this, "finder.inFlightRequests.length") === 0 && promiseCheckCount > 10) {
            // Ember.run.sync()
            scheduleOnce("afterRender", () => {
              later(resolve, 250)
            })
            return
          } else {
            poll()
          }
        }, 100)
      }
      poll()
    })
    renderPromise.then(() => {
      console.log("Adding print-loaded-div")
      // Add an element that Puppeteer can wait for.
      const printLoadedDiv = document.createElement("div")
      printLoadedDiv.id = "print-loaded-div"
      document.body.appendChild(printLoadedDiv)
    })

    return new Promise((resolve, _reject) => resolve())
  }
  afterModel() {}
}
